<template>
	<BaseCmsPage @load="onPageLoad">
		<CmsCheckoutWrapper>
			<ClientOnly>
				<form @submit.prevent="onSubmit">
					<div class="wc-form wc-payment-second-form floating-labels-checkout floating-labels">
						<div class="wc-form-col1">
							<div class="wc-title">
								<template v-if="additionalPaymentRoute == 1"><BaseCmsLabel code="new_payment_h1_additpayment" /></template>
								<template v-else><BaseCmsLabel code="new_payment_title" /></template>
							</div>

							<div v-if="paymentError" class="unavailable-item special">
								<div class="title"><strong v-html="error_message"></strong></div>
								<div class="btn-hidde" @click="hiddeErrorMessage()">
									<span><BaseCmsLabel code="hidde_error" /></span>
								</div>
							</div>

							<div class="wc-subtitle" v-if="data && data.cart.can_change_payment == true && additionalPaymentRoute.value == 1"><BaseCmsLabel code="new_payment_content_additpayment" /></div>
							<div class="wc-subtitle" v-if="data && data.cart.can_change_payment == false && additionalPaymentRoute.value != 1"><BaseCmsLabel code="new_payment_error" /></div>
							<div class="wc-subtitle" v-if="data && data.cart.can_change_payment == false && additionalPaymentRoute.value == 1"><BaseCmsLabel code="payment_note_additpayment" /></div>
							<div class="wc-payments" v-if="data && data.cart.can_change_payment">
								<div v-if="checkoutLoading" class="wc-payments-loader"><span></span></div>
								<WebshopPaymentOptions v-for="payment in data.cart.payments.available" :key="payment.id" :cart="data" :data="payment" />
							</div>
						</div>

						<template v-if="data && data.cart.can_change_payment == false && additionalPaymentRoute.value == 1"></template>
						<template v-else>
							<WebshopSidebarBankart :meta="meta" review="true" mode="newPaymentMode" />
						</template>
						<WebshopWidgetFixedbarBankart :meta="meta" review="true" mode="newPaymentMode" />
					</div>
				</form>
				<template #fallback>
					<BaseThemeUiLoading />
				</template>
			</ClientOnly>
		</CmsCheckoutWrapper>
	</BaseCmsPage>
</template>

<script setup>
	import {useForm} from 'vee-validate';

	const apiRoutes = useApiRoutes();
	const webshop = useWebshop();
	const endpoints = useEndpoints();
	const labels = useLabels();
	const { checkoutLoading, orderData, formValid, orderSuccess, creditCard, leanpayData, additionalPayment, additionalPaymentRoute, paymentError, newPayment, newPaymentId, newPaymentCard, newPaymentInstallment, newPaymentOptions, paymentgateway } = useCheckout();
	const data = computed(() => {
		return (additionalPaymentRoute.value == 1) ? additionalPayment.value : orderData.value;
	})
	let urlNewPayment = false;
	newPayment.value = 1;

	const newPaymentIdData = computed(() => {
		return newPaymentId.value
	})
	const newPaymentOptionsData = computed(() => {
		return newPaymentOptions.value
	})
	const newPaymentCardData = computed(() => {
		return newPaymentCard.value
	})

	//validation
	const { meta } = useForm()
	watch([ meta, newPaymentIdData, newPaymentCardData, newPaymentOptionsData ], ( newValue ) => {
		formValid.value = ((newValue[0].valid && newValue[1] != 0 && newValue[3] == null) || (newValue[0].valid && newValue[1] != 0 && newValue[3] != null && newValue[2] != 0)) ? 1 : 0
	})

	//hidde error message
	function hiddeErrorMessage() {
		paymentError.value = null;
	}

	//error message
	let error_message = computed(() => {
		let error_code_message = paymentError.value != null ? paymentError.value.error_code : null;
		let error_code = error_code_message ? error_code_message.replace('error_paid_', '') : null;
		if (error_code) {
			let payment_errors = labels.get('bankart_error_codes');
			let payment_errors_split = payment_errors.split('\n');
			let message;

			payment_errors_split.forEach(el => {
				let [payment_error_code, payment_error_message] = el.split('|');
				if (payment_error_code == error_code) {
					message = payment_error_message;
				}
			});

			if (!message) {
				message = labels.get('bankart_error_code_generic');
			}

			return message;
		} else if (paymentError.value && paymentError.value.label_name) {
			return labels.get(paymentError.value.label_name);
		}
	});

	//bankart script
	function bankartScript() {
		let s = document.createElement("script")
		function setAttributes(el, attrs) {
			for(var key in attrs) {
				el.setAttribute(key, attrs[key])
			}
		}
		setAttributes(s, {"data-main": "payment-js", "src": paymentgateway.value.script_url})
		document.head.appendChild(s)
	}

	onMounted(async() => {
		newPayment.value = 1;
		const url = window.location.href;
		const searchParams = new URL(url).searchParams;

		if(searchParams.get('webshopadditionalpayment') == 1) {
			urlNewPayment = true;
		}

		if((urlNewPayment == true) || (additionalPaymentRoute.value == 1 && searchParams.get('order_identificator'))) {
			additionalPaymentRoute.value = 1
			const urlId = searchParams.get('order_identificator')
			const webshopOrderId = endpoints.get('_get_hapi_webshop_additionalpayment');
			const webshopOrder = (urlNewPayment) ? webshopOrderId.replace("%ID%-%CODE%", urlId) + '?new_payment=1': webshopOrderId.replace("%ID%-%CODE%", urlId)

			async function orderDataFunction() {
				await useApi(webshopOrder, {method: 'GET'})
				.then(async (res) => {
					additionalPayment.value = res.data;

					if(res.data.cart.payment_type == 'credit_cart_form') {
						const paymentgatewayId = endpoints.get('_get_hapi_webshop_additionalpayment_specific_paymentgateway_data');
						const paymentgatewayData = paymentgatewayId.replace("%ID%-%CODE%", urlId)
						await useApi(paymentgatewayData, {method: 'GET'})
						.then(async (res) => {
							paymentgateway.value = res.data;
							let pgMode = paymentgateway.value.pg_mode
							let pgModeFillFields = 'phone_email'
							if(pgMode == 'cc') {
								pgModeFillFields = 'cc_first_name,cc_last_name'
							}
							let apiExtraValue = '?type=webshop.' + pgMode + '&order_identificator=' + urlId + '-webshopadditionalpayment&fill_fields=' + pgModeFillFields + '&change_fields=cc_number:ignore_validation=1,cc_number:type=hidden,cc_cvv:ignore_validation=1,cc_cvv:type=hidden,cc_expire_month:ignore_validation=1,cc_expire_month:type=hidden,cc_expire_year:ignore_validation=1,cc_expire_year:type=hidden';
							await useApi(`${endpoints.get('_get_hapi_customer_fields')}${apiExtraValue}`)
							.then(res => creditCard.value = res.data)
							if(res.success && paymentgateway.value && paymentgateway.value.pg_mode == 'cc') {
								bankartScript();
							}
						})
					}
				})
			}
			orderDataFunction();
		}

		if(urlNewPayment == false && orderSuccess.value == 0 && additionalPaymentRoute.value == 0 && searchParams.get('order_identificator')) {
			const urlId = searchParams.get('order_identificator')
			const webshopOrderId = endpoints.get('_get_hapi_webshop_order');
			const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", urlId) + '?new_payment=1'

			async function orderDataFunction() {
				await useApi(webshopOrder, {method: 'GET'})
				.then(async (res) => {
					if(res.success) {
						orderData.value = res.data;

						if(res.data.cart.payment_type == 'credit_cart_form') {
							const paymentgatewayId = endpoints.get('_get_hapi_webshop_order_specific_paymentgateway_data');
							const paymentgatewayData = paymentgatewayId.replace("%ID%-%CODE%", urlId);
							await useApi(paymentgatewayData, {method: 'GET'})
							.then(async (res) => {
								paymentgateway.value = res.data;
								let pgMode = paymentgateway.value.pg_mode;
								let pgModeFillFields = 'phone_email'
								if(pgMode == 'cc') {
									pgModeFillFields = 'cc_first_name,cc_last_name'
								}
								let apiExtraValue = '?type=webshop.' + pgMode + '&order_identificator=' + urlId + '&fill_fields=' + pgModeFillFields + '&change_fields=cc_number:ignore_validation=1,cc_number:type=hidden,cc_cvv:ignore_validation=1,cc_cvv:type=hidden,cc_expire_month:ignore_validation=1,cc_expire_month:type=hidden,cc_expire_year:ignore_validation=1,cc_expire_year:type=hidden';
								await useApi(`${endpoints.get('_get_hapi_customer_fields')}${apiExtraValue}`)
								.then(res => creditCard.value = res.data)
								if(res.success && paymentgateway.value && paymentgateway.value.pg_mode == 'cc') {
									bankartScript();
								}
							})
						}
					}
				})
			}
			orderDataFunction();
		}

		orderSuccess.value = 0;
	})

	async function onSubmit() {
		checkoutLoading.value = true;

		const id_code = (additionalPaymentRoute.value == 1) ? additionalPayment.value.cart.id + '-' + additionalPayment.value.cart.code : orderData.value.cart.order_id + '-' + orderData.value.cart.order_code;
		const webshopOrderId = (additionalPaymentRoute.value == 1) ? endpoints.get('_put_hapi_webshop_additionalpayment') : endpoints.get('_put_hapi_webshop_order');
		const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", id_code);


		const newPaymentCardValue = (newPaymentId.value == 3 && newPaymentCard.value != 0) ? newPaymentCard.value.toString() : 0;
		const newPaymentInstallmentsValue = (newPaymentId.value == 34 && newPaymentInstallment.value != null) ? newPaymentInstallment.value.toString() : 0;

		await useApi(webshopOrder, {method: 'PUT', body: {payment: newPaymentId.value, payment_option_id: newPaymentCardValue, cc_installments: newPaymentInstallmentsValue}}, {lang: false})
		.then(async (res) => {
			if(res.success) {
				setTimeout(async() => {
					const webshopOrderId = (additionalPaymentRoute.value == 1) ? endpoints.get('_get_hapi_webshop_additionalpayment') : endpoints.get('_get_hapi_webshop_order');
					const webshopOrder = webshopOrderId.replace("%ID%-%CODE%", id_code);

					await useApi(webshopOrder, {method: 'GET'})
					.then(async (res) => {
						if(additionalPaymentRoute.value == 1) {
							additionalPayment.value = res.data;
							orderData.value = res.data;
						} else {
							orderData.value = res.data;
						}
						if(res.data?.cart?.payment_type == null) {
							orderSuccess.value = 1;
							if(additionalPaymentRoute.value == 1) {
								await navigateTo({
									path: apiRoutes.getAppUrl('webshop_additionalpayments_thank_you'),
									query: {order_identificator: id_code, webshopadditionalpayment: '1'}
								});
							} else {
								await navigateTo({
									path: apiRoutes.getAppUrl('webshop_thank_you'),
									query: {order_identificator: id_code}
								});
							}

							checkoutLoading.value = false;
						} else if(res.data?.cart?.payment_type == 'redirect') {
							const createPaymentId = endpoints.get('_get_hapi_webshop_create_payment');
							const createPayment = createPaymentId.replace("%ID%-%CODE%", id_code);

							await useApi(createPayment, {method: 'GET'})
							.then(async (res) => {
								if(res.success) {
									const link = res.data.redirect_url;
									const hiddenForm = (res.data.hidden_form) ? res.data.hidden_form : null;
									if(hiddenForm != null) {
										leanpayData.value = res.data;
										await navigateTo(apiRoutes.getAppUrl('webshop_payment_form_autosubmit'));
									} else {
										window.location.href = link;
									}
								} else if (res.data.label_name === 'error_empty_payment_form') {
									paymentError.value = res.data;
									await navigateTo({
										path: apiRoutes.getAppUrl('webshop_payment_new'),
										query: {order_identificator: id_code}
									});
									checkoutLoading.value = false;
								}
							})

							checkoutLoading.value = false;
						} else if(res.data?.cart?.payment_type == 'credit_cart_form') {
							orderSuccess.value = 1
							if(additionalPaymentRoute.value == 1) {
								await navigateTo({
									path: apiRoutes.getAppUrl('webshop_payment_create'),
									query: {order_identificator: id_code, webshopadditionalpayment: '1'}
								});
							} else {
								await navigateTo({
									path: apiRoutes.getAppUrl('webshop_payment_create'),
									query: {order_identificator: id_code}
								});
							}
							const paymentgatewayId = (additionalPaymentRoute.value == 1) ? endpoints.get('_get_hapi_webshop_additionalpayment_specific_paymentgateway_data') : endpoints.get('_get_hapi_webshop_order_specific_paymentgateway_data');
							const paymentgatewayData = paymentgatewayId.replace("%ID%-%CODE%", id_code);
							await useApi(paymentgatewayData, {method: 'GET'})
							.then(async (res) => {
								paymentgateway.value = res.data;
								let pgMode = paymentgateway.value.pg_mode;
								let pgModeFillFields = 'phone_email'
								if(pgMode == 'cc') {
									pgModeFillFields = 'cc_first_name,cc_last_name'
								}
								if(additionalPaymentRoute.value == 1) {
									let apiExtraValue = '?type=webshop.'+pgMode+'&order_identificator='+id_code+'-webshopadditionalpayment&fill_fields='+pgModeFillFields+'&change_fields=cc_number:ignore_validation=1,cc_number:type=hidden,cc_cvv:ignore_validation=1,cc_cvv:type=hidden,cc_expire_month:ignore_validation=1,cc_expire_month:type=hidden,cc_expire_year:ignore_validation=1,cc_expire_year:type=hidden';
									await useApi(`${endpoints.get('_get_hapi_customer_fields')}${apiExtraValue}`, {
										method: 'GET'
									}).then(res => creditCard.value = res.data)
								} else {
									let apiExtraValue = '?type=webshop.'+pgMode+'&order_identificator='+id_code+'&fill_fields='+pgModeFillFields+'&change_fields=cc_number:ignore_validation=1,cc_number:type=hidden,cc_cvv:ignore_validation=1,cc_cvv:type=hidden,cc_expire_month:ignore_validation=1,cc_expire_month:type=hidden,cc_expire_year:ignore_validation=1,cc_expire_year:type=hidden';
									await useApi(`${endpoints.get('_get_hapi_customer_fields')}${apiExtraValue}`, {
										method: 'GET'
									}).then(res => creditCard.value = res.data)
								}
								if(res.success && paymentgateway.value && paymentgateway.value.pg_mode == 'cc') {
									bankartScript();
								}
							})
						}
					})
				},2000)
			} else {
				await webshop.fetchCart();
				orderSuccess.value = 1;
				await navigateTo(apiRoutes.getAppUrl('webshop_failed_order'));

				checkoutLoading.value = false;
			}

			newPayment.value = null;
			newPaymentOptions.value = null;
			newPaymentId.value = 0;
			newPaymentCard.value = 0;
			newPaymentInstallment.value = 1;
		})
	}

	//gtm
	const gtm = useGtmBB();

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>

<style lang="less" scoped>
	*{
		--sideOffset: 40px;
	}
	@media (max-width: @t){
		*{
			--sideOffset: 25px;
		}
	}
	@media (max-width: @m){
		*{
			--sideOffset: 20px;
		}
		.btn{height: 54px; font-size: 16px; line-height: 1;}
		.btn-icon-arrow span:before{top: 4px; font-size: 9px;}
	}

	.wc-subtitle{
		display: block; margin: 20px 0 12px; font-size: 17px; font-weight: 600;

		@media (max-width: @m){margin: 15px 0 10px; font-size: 15px;}
	}

	.wc-payment-second-form{margin-top: 30px;}
	.wc-payments{
		margin-top: 20px; position: relative;

		@media (max-width: @m){margin-bottom: 30px;}
	}
	.wc-payments-loader{
		display: flex; align-items: center; justify-content: center; background: rgba(255, 255, 255, 0.3); position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 11;
		//span{width: 60px; height: 60px; background: url(assets/images/loader.svg) no-repeat center; background-size: 60px; z-index: 11;}
	}
</style>
